import { combineReducers } from 'redux'
import { createReducer } from 'typesafe-actions'
import { RequestStatus } from '../../responses/response'
import { taskActions } from '../data/task/task-actions'

export interface SingleTaskState {
    status: RequestStatus,
}

export const singleTaskReducer = combineReducers<SingleTaskState>({
    status: createReducer<RequestStatus>(RequestStatus.INITIAL)
        .handleAction(taskActions.get.request, () => RequestStatus.FETCHING)
        .handleAction(taskActions.get.success, () => RequestStatus.SUCCESS)
        .handleAction(taskActions.get.failure, () => RequestStatus.FAILURE),
})